import { render, staticRenderFns } from "./UpdateByCBHPMModal.vue?vue&type=template&id=fbf620f6"
import script from "./UpdateByCBHPMModal.vue?vue&type=script&lang=js"
export * from "./UpdateByCBHPMModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports